<template>
    <div class="wrapper">

        <header-main></header-main>

        <main class="page page--pt">
            <section>
                <div class="search__container">
                    <div class="search__filters">
                        <div class="search__input">
                            <label class="search__label search-input">
                                <svg width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M25.0246 23.3088L20.9163 19.2125C22.2418 17.5238 22.961 15.4385 22.9583 13.2917C22.9583 11.3798 22.3914 9.51083 21.3292 7.92116C20.267 6.33148 18.7573 5.09248 16.9909 4.36084C15.2246 3.62919 13.2809 3.43776 11.4058 3.81075C9.53065 4.18374 7.80821 5.1044 6.45631 6.45631C5.1044 7.80821 4.18374 9.53065 3.81075 11.4058C3.43776 13.2809 3.62919 15.2246 4.36084 16.9909C5.09248 18.7573 6.33148 20.267 7.92116 21.3292C9.51083 22.3914 11.3798 22.9583 13.2917 22.9583C15.4385 22.961 17.5238 22.2418 19.2125 20.9163L23.3088 25.0246C23.4211 25.1378 23.5547 25.2277 23.702 25.2891C23.8492 25.3504 24.0072 25.382 24.1667 25.382C24.3262 25.382 24.4841 25.3504 24.6314 25.2891C24.7786 25.2277 24.9123 25.1378 25.0246 25.0246C25.1378 24.9123 25.2277 24.7786 25.2891 24.6314C25.3504 24.4841 25.382 24.3262 25.382 24.1667C25.382 24.0072 25.3504 23.8492 25.2891 23.702C25.2277 23.5547 25.1378 23.4211 25.0246 23.3088ZM6.04167 13.2917C6.04167 11.8578 6.46688 10.456 7.26352 9.26379C8.06016 8.07153 9.19245 7.14228 10.5172 6.59354C11.842 6.04481 13.2997 5.90123 14.7061 6.18098C16.1124 6.46072 17.4043 7.15122 18.4182 8.16515C19.4321 9.17908 20.1226 10.4709 20.4024 11.8773C20.6821 13.2836 20.5385 14.7414 19.9898 16.0661C19.4411 17.3909 18.5118 18.5232 17.3196 19.3198C16.1273 20.1165 14.7256 20.5417 13.2917 20.5417C11.3689 20.5417 9.52479 19.7778 8.16515 18.4182C6.80551 17.0586 6.04167 15.2145 6.04167 13.2917Z"
                                        fill="white"
                                    ></path>
                                </svg>
                                <input
                                    v-model="data.query"
                                    @input.prevent="changeSearch()"
                                    autocomplete="off" 
                                    type="text" 
                                    :placeholder="$store.state.translation.search.text1" 
                                    class="input"/>
                            </label>
                            <svg width="106" height="106" viewBox="0 0 106 106" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M54.7825 5.02247C53.6325 6.17247 51.7725 6.17247 50.6225 5.02247C49.4725 3.87247 49.4725 2.0125 50.6225 0.8625C51.7725 -0.2875 53.6325 -0.2875 54.7825 0.8625C55.9325 2.0125 55.9325 3.87247 54.7825 5.02247ZM67.2225 13.3025C66.0725 12.1525 64.2125 12.1525 63.0625 13.3025C61.9125 14.4525 61.9125 16.3125 63.0625 17.4625C64.2125 18.6125 66.0725 18.6125 67.2225 17.4625C68.3725 16.3125 68.3725 14.4525 67.2225 13.3025ZM79.6625 25.7425C78.5125 24.5925 76.6525 24.5925 75.5025 25.7425C74.3525 26.8925 74.3525 28.7525 75.5025 29.9025C76.6525 31.0525 78.5125 31.0525 79.6625 29.9025C80.8125 28.7525 80.8125 26.8925 79.6625 25.7425ZM92.1025 38.1825C90.9525 37.0325 89.0925 37.0325 87.9425 38.1825C86.7925 39.3325 86.7925 41.1925 87.9425 42.3425C89.0925 43.4925 90.9525 43.4925 92.1025 42.3425C93.2525 41.1925 93.2525 39.3325 92.1025 38.1825ZM104.542 50.6225C103.392 49.4725 101.533 49.4725 100.383 50.6225C99.2325 51.7725 99.2325 53.6325 100.383 54.7825C101.533 55.9325 103.392 55.9325 104.542 54.7825C105.692 53.6325 105.692 51.7725 104.542 50.6225ZM42.3425 13.3025C41.1925 12.1525 39.3325 12.1525 38.1825 13.3025C37.0325 14.4525 37.0325 16.3125 38.1825 17.4625C39.3325 18.6125 41.1925 18.6125 42.3425 17.4625C43.4925 16.3125 43.4925 14.4525 42.3425 13.3025ZM54.7825 25.7425C53.6325 24.5925 51.7725 24.5925 50.6225 25.7425C49.4725 26.8925 49.4725 28.7525 50.6225 29.9025C51.7725 31.0525 53.6325 31.0525 54.7825 29.9025C55.9325 28.7525 55.9325 26.8925 54.7825 25.7425ZM67.2225 38.1825C66.0725 37.0325 64.2125 37.0325 63.0625 38.1825C61.9125 39.3325 61.9125 41.1925 63.0625 42.3425C64.2125 43.4925 66.0725 43.4925 67.2225 42.3425C68.3725 41.1925 68.3725 39.3325 67.2225 38.1825ZM79.6625 50.6225C78.5125 49.4725 76.6525 49.4725 75.5025 50.6225C74.3525 51.7725 74.3525 53.6325 75.5025 54.7825C76.6525 55.9325 78.5125 55.9325 79.6625 54.7825C80.8125 53.6325 80.8125 51.7725 79.6625 50.6225ZM92.1025 63.0625C90.9525 61.9125 89.0925 61.9125 87.9425 63.0625C86.7925 64.2125 86.7925 66.0725 87.9425 67.2225C89.0925 68.3725 90.9525 68.3725 92.1025 67.2225C93.2525 66.0725 93.2525 64.2125 92.1025 63.0625ZM29.9025 25.7425C28.7525 24.5925 26.8925 24.5925 25.7425 25.7425C24.5925 26.8925 24.5925 28.7525 25.7425 29.9025C26.8925 31.0525 28.7525 31.0525 29.9025 29.9025C31.0525 28.7525 31.0525 26.8925 29.9025 25.7425ZM42.3425 38.1825C41.1925 37.0325 39.3325 37.0325 38.1825 38.1825C37.0325 39.3325 37.0325 41.1925 38.1825 42.3425C39.3325 43.4925 41.1925 43.4925 42.3425 42.3425C43.4925 41.1925 43.4925 39.3325 42.3425 38.1825ZM54.7825 50.6225C53.6325 49.4725 51.7725 49.4725 50.6225 50.6225C49.4725 51.7725 49.4725 53.6325 50.6225 54.7825C51.7725 55.9325 53.6325 55.9325 54.7825 54.7825C55.9325 53.6325 55.9325 51.7725 54.7825 50.6225ZM67.2225 63.0625C66.0725 61.9125 64.2125 61.9125 63.0625 63.0625C61.9125 64.2125 61.9125 66.0725 63.0625 67.2225C64.2125 68.3725 66.0725 68.3725 67.2225 67.2225C68.3725 66.0725 68.3725 64.2125 67.2225 63.0625ZM79.6625 75.5025C78.5125 74.3525 76.6525 74.3525 75.5025 75.5025C74.3525 76.6525 74.3525 78.5125 75.5025 79.6625C76.6525 80.8125 78.5125 80.8125 79.6625 79.6625C80.8125 78.5125 80.8125 76.6425 79.6625 75.5025ZM17.4625 38.1825C16.3125 37.0325 14.4525 37.0325 13.3025 38.1825C12.1525 39.3325 12.1525 41.1925 13.3025 42.3425C14.4525 43.4925 16.3125 43.4925 17.4625 42.3425C18.6125 41.1925 18.6125 39.3325 17.4625 38.1825ZM29.9025 50.6225C28.7525 49.4725 26.8925 49.4725 25.7425 50.6225C24.5925 51.7725 24.5925 53.6325 25.7425 54.7825C26.8925 55.9325 28.7525 55.9325 29.9025 54.7825C31.0525 53.6325 31.0525 51.7725 29.9025 50.6225ZM42.3425 63.0625C41.1925 61.9125 39.3325 61.9125 38.1825 63.0625C37.0325 64.2125 37.0325 66.0725 38.1825 67.2225C39.3325 68.3725 41.1925 68.3725 42.3425 67.2225C43.4925 66.0725 43.4925 64.2125 42.3425 63.0625ZM54.7825 75.5025C53.6325 74.3525 51.7725 74.3525 50.6225 75.5025C49.4725 76.6525 49.4725 78.5125 50.6225 79.6625C51.7725 80.8125 53.6325 80.8125 54.7825 79.6625C55.9325 78.5125 55.9325 76.6425 54.7825 75.5025ZM67.2225 87.9425C66.0725 86.7925 64.2125 86.7925 63.0625 87.9425C61.9125 89.0925 61.9125 90.9525 63.0625 92.1025C64.2125 93.2525 66.0725 93.2525 67.2225 92.1025C68.3725 90.9525 68.3725 89.0825 67.2225 87.9425ZM5.02253 50.6225C3.87253 49.4725 2.0125 49.4725 0.8625 50.6225C-0.2875 51.7725 -0.2875 53.6325 0.8625 54.7825C2.0125 55.9325 3.87253 55.9325 5.02253 54.7825C6.17253 53.6325 6.17253 51.7725 5.02253 50.6225ZM17.4625 63.0625C16.3125 61.9125 14.4525 61.9125 13.3025 63.0625C12.1525 64.2125 12.1525 66.0725 13.3025 67.2225C14.4525 68.3725 16.3125 68.3725 17.4625 67.2225C18.6125 66.0725 18.6125 64.2125 17.4625 63.0625ZM29.9025 75.5025C28.7525 74.3525 26.8925 74.3525 25.7425 75.5025C24.5925 76.6525 24.5925 78.5125 25.7425 79.6625C26.8925 80.8125 28.7525 80.8125 29.9025 79.6625C31.0525 78.5125 31.0525 76.6425 29.9025 75.5025ZM42.3425 87.9425C41.1925 86.7925 39.3325 86.7925 38.1825 87.9425C37.0325 89.0925 37.0325 90.9525 38.1825 92.1025C39.3325 93.2525 41.1925 93.2525 42.3425 92.1025C43.4925 90.9525 43.4925 89.0825 42.3425 87.9425ZM54.7825 100.372C53.6325 99.2225 51.7725 99.2225 50.6225 100.372C49.4725 101.522 49.4725 103.382 50.6225 104.532C51.7725 105.682 53.6325 105.682 54.7825 104.532C55.9325 103.392 55.9325 101.522 54.7825 100.372Z"
                                    fill="#E9417D"
                                ></path>
                            </svg>
                            <svg width="150" height="4" viewBox="0 0 150 4" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M38.3109 3.86002C37.2509 3.86002 36.3809 2.99999 36.3809 1.92999C36.3809 0.869993 37.2409 0 38.3109 0C39.3709 0 40.2408 0.859993 40.2408 1.92999C40.2408 2.99999 39.3809 3.86002 38.3109 3.86002Z"
                                    fill="#FFFF00"
                                ></path>
                                <path
                                    d="M1.92999 3.86002C0.869993 3.86002 0 2.99999 0 1.92999C0 0.869993 0.859993 0 1.92999 0C2.99999 0 3.85999 0.859993 3.85999 1.92999C3.85999 2.99999 2.98999 3.86002 1.92999 3.86002Z"
                                    fill="#FFFF00"
                                ></path>
                                <path
                                    d="M56.4496 3.86002C55.3896 3.86002 54.5195 2.99999 54.5195 1.92999C54.5195 0.869993 55.3796 0 56.4496 0C57.5096 0 58.3795 0.859993 58.3795 1.92999C58.3795 2.99999 57.5096 3.86002 56.4496 3.86002Z"
                                    fill="#FFFF00"
                                ></path>
                                <path
                                    d="M74.5901 3.86002C73.5301 3.86002 72.6602 2.99999 72.6602 1.92999C72.6602 0.869993 73.5201 0 74.5901 0C75.6501 0 76.5201 0.859993 76.5201 1.92999C76.5101 2.99999 75.6501 3.86002 74.5901 3.86002Z"
                                    fill="#FFFF00"
                                ></path>
                                <path
                                    d="M92.7191 3.86002C91.6591 3.86002 90.7891 2.99999 90.7891 1.92999C90.7891 0.869993 91.6491 0 92.7191 0C93.7791 0 94.649 0.859993 94.649 1.92999C94.649 2.99999 93.7791 3.86002 92.7191 3.86002Z"
                                    fill="#FFFF00"
                                ></path>
                                <path
                                    d="M147.129 3.86002C146.069 3.86002 145.199 2.99999 145.199 1.92999C145.199 0.869993 146.059 0 147.129 0C148.189 0 149.059 0.859993 149.059 1.92999C149.059 2.99999 148.189 3.86002 147.129 3.86002Z"
                                    fill="#FFFF00"
                                ></path>
                            </svg>
                            <svg width="92" height="54" viewBox="0 0 92 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1 52.45L52.44 1" stroke="white" stroke-width="2" stroke-miterlimit="10"></path>
                                <path d="M13.7109 52.45L65.1609 1" stroke="white" stroke-width="2" stroke-miterlimit="10"></path>
                                <path d="M26.4297 52.45L77.8697 1" stroke="#8BD2BD" stroke-width="2" stroke-miterlimit="10"></path>
                                <path d="M39.1406 52.45L90.5906 1" stroke="#FFE031" stroke-width="2" stroke-miterlimit="10"></path>
                            </svg>
                            <svg width="88" height="88" viewBox="0 0 88 88" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M84.6065 6.7861C82.7366 6.7861 81.213 5.26268 81.213 3.39304C81.213 1.5234 82.7366 0 84.6065 0C86.4764 0 88 1.5234 88 3.39304C88 5.26268 86.4879 6.7861 84.6065 6.7861ZM88 23.6936C88 21.824 86.4764 20.3006 84.6065 20.3006C82.7366 20.3006 81.213 21.824 81.213 23.6936C81.213 25.5633 82.7366 27.0867 84.6065 27.0867C86.4879 27.0867 88 25.5748 88 23.6936ZM88 43.9942C88 42.1246 86.4764 40.6012 84.6065 40.6012C82.7366 40.6012 81.213 42.1246 81.213 43.9942C81.213 45.8639 82.7366 47.3873 84.6065 47.3873C86.4879 47.3873 88 45.8754 88 43.9942ZM88 64.2948C88 62.4252 86.4764 60.9018 84.6065 60.9018C82.7366 60.9018 81.213 62.4252 81.213 64.2948C81.213 66.1645 82.7366 67.6879 84.6065 67.6879C86.4879 67.6994 88 66.176 88 64.2948ZM88 84.607C88 82.7373 86.4764 81.2139 84.6065 81.2139C82.7366 81.2139 81.213 82.7373 81.213 84.607C81.213 86.4766 82.7366 88 84.6065 88C86.4879 88 88 86.4766 88 84.607ZM67.6967 3.39304C67.6967 1.5234 66.1731 0 64.3033 0C62.4334 0 60.9098 1.5234 60.9098 3.39304C60.9098 5.26268 62.4334 6.7861 64.3033 6.7861C66.1847 6.7861 67.6967 5.26268 67.6967 3.39304ZM67.6967 23.6936C67.6967 21.824 66.1731 20.3006 64.3033 20.3006C62.4334 20.3006 60.9098 21.824 60.9098 23.6936C60.9098 25.5633 62.4334 27.0867 64.3033 27.0867C66.1847 27.0867 67.6967 25.5748 67.6967 23.6936ZM67.6967 43.9942C67.6967 42.1246 66.1731 40.6012 64.3033 40.6012C62.4334 40.6012 60.9098 42.1246 60.9098 43.9942C60.9098 45.8639 62.4334 47.3873 64.3033 47.3873C66.1847 47.3873 67.6967 45.8754 67.6967 43.9942ZM67.6967 64.2948C67.6967 62.4252 66.1731 60.9018 64.3033 60.9018C62.4334 60.9018 60.9098 62.4252 60.9098 64.2948C60.9098 66.1645 62.4334 67.6879 64.3033 67.6879C66.1847 67.6994 67.6967 66.176 67.6967 64.2948ZM67.6967 84.607C67.6967 82.7373 66.1731 81.2139 64.3033 81.2139C62.4334 81.2139 60.9098 82.7373 60.9098 84.607C60.9098 86.4766 62.4334 88 64.3033 88C66.1847 88 67.6967 86.4766 67.6967 84.607ZM47.3935 3.39304C47.3935 1.5234 45.8699 0 44 0C42.1301 0 40.6065 1.5234 40.6065 3.39304C40.6065 5.26268 42.1301 6.7861 44 6.7861C45.8699 6.7861 47.3935 5.26268 47.3935 3.39304ZM47.3935 23.6936C47.3935 21.824 45.8699 20.3006 44 20.3006C42.1301 20.3006 40.6065 21.824 40.6065 23.6936C40.6065 25.5633 42.1301 27.0867 44 27.0867C45.8699 27.0867 47.3935 25.5748 47.3935 23.6936ZM47.3935 43.9942C47.3935 42.1246 45.8699 40.6012 44 40.6012C42.1301 40.6012 40.6065 42.1246 40.6065 43.9942C40.6065 45.8639 42.1301 47.3873 44 47.3873C45.8699 47.3873 47.3935 45.8754 47.3935 43.9942ZM47.3935 64.2948C47.3935 62.4252 45.8699 60.9018 44 60.9018C42.1301 60.9018 40.6065 62.4252 40.6065 64.2948C40.6065 66.1645 42.1301 67.6879 44 67.6879C45.8699 67.6879 47.3935 66.176 47.3935 64.2948ZM47.3935 84.607C47.3935 82.7373 45.8699 81.2139 44 81.2139C42.1301 81.2139 40.6065 82.7373 40.6065 84.607C40.6065 86.4766 42.1301 88 44 88C45.8699 88 47.3935 86.4766 47.3935 84.607ZM27.0902 3.39304C27.0902 1.5234 25.5666 0 23.6967 0C21.8269 0 20.3033 1.5234 20.3033 3.39304C20.3033 5.26268 21.8269 6.7861 23.6967 6.7861C25.5666 6.7861 27.0902 5.26268 27.0902 3.39304ZM27.0902 23.6936C27.0902 21.824 25.5666 20.3006 23.6967 20.3006C21.8269 20.3006 20.3033 21.824 20.3033 23.6936C20.3033 25.5633 21.8269 27.0867 23.6967 27.0867C25.5666 27.0867 27.0902 25.5748 27.0902 23.6936ZM27.0902 43.9942C27.0902 42.1246 25.5666 40.6012 23.6967 40.6012C21.8269 40.6012 20.3033 42.1246 20.3033 43.9942C20.3033 45.8639 21.8269 47.3873 23.6967 47.3873C25.5666 47.3873 27.0902 45.8754 27.0902 43.9942ZM27.0902 64.2948C27.0902 62.4252 25.5666 60.9018 23.6967 60.9018C21.8269 60.9018 20.3033 62.4252 20.3033 64.2948C20.3033 66.1645 21.8269 67.6879 23.6967 67.6879C25.5666 67.6994 27.0902 66.176 27.0902 64.2948ZM27.0902 84.607C27.0902 82.7373 25.5666 81.2139 23.6967 81.2139C21.8269 81.2139 20.3033 82.7373 20.3033 84.607C20.3033 86.4766 21.8269 88 23.6967 88C25.5666 88 27.0902 86.4766 27.0902 84.607ZM6.78699 3.39304C6.78699 1.5234 5.26338 0 3.3935 0C1.52361 0 0 1.5234 0 3.39304C0 5.26268 1.52361 6.7861 3.3935 6.7861C5.26338 6.7861 6.78699 5.26268 6.78699 3.39304ZM6.78699 23.6936C6.78699 21.824 5.26338 20.3006 3.3935 20.3006C1.52361 20.3006 0 21.824 0 23.6936C0 25.5633 1.52361 27.0867 3.3935 27.0867C5.26338 27.0867 6.78699 25.5748 6.78699 23.6936ZM6.78699 43.9942C6.78699 42.1246 5.26338 40.6012 3.3935 40.6012C1.52361 40.6012 0 42.1246 0 43.9942C0 45.8639 1.52361 47.3873 3.3935 47.3873C5.26338 47.3873 6.78699 45.8754 6.78699 43.9942ZM6.78699 64.2948C6.78699 62.4252 5.26338 60.9018 3.3935 60.9018C1.52361 60.9018 0 62.4252 0 64.2948C0 66.1645 1.52361 67.6879 3.3935 67.6879C5.26338 67.6994 6.78699 66.176 6.78699 64.2948ZM6.78699 84.607C6.78699 82.7373 5.26338 81.2139 3.3935 81.2139C1.52361 81.2139 0 82.7373 0 84.607C0 86.4766 1.52361 88 3.3935 88C5.26338 88 6.78699 86.4766 6.78699 84.607Z"
                                    fill="#FFC263"
                                ></path>
                            </svg>
                        </div>
                        <div class="search__selects filters_search_select">
                            <div class="select select_form _select-active">
                                <v-select 
                                    :options="filters.providers"
                                    v-model="data.provider"
                                    @input="changeSearch()"
                                    :searchable="false"
                                    :placeholder="$store.state.translation.search.text2"
                                    class="filter"
                                    label="name"
                                    data-id="1">
                                    <template v-slot:no-options="{ search, searching }">
                                      <template v-if="searching">
                                        {{ $store.state.translation.default.select_not_found }}
                                      </template>
                                    </template>
                                </v-select>
                            </div>
                            <div class="select select_form _select-active" data-id="2">
                                <v-select 
                                    :options="filters.categories"
                                    v-model="data.category"
                                    @input="changeSearch()"
                                    :searchable="false"
                                    :placeholder="$store.state.translation.search.text3"
                                    class="filter"
                                    label="name"
                                    data-id="1">
                                    <template v-slot:no-options="{ search, searching }">
                                      <template v-if="searching">
                                         {{ $store.state.translation.default.select_not_found }}
                                      </template>
                                    </template>
                                </v-select>
                            </div>
                            <div class="select select_form _select-active" data-id="4">
                                <v-select 
                                    :options="filters.options"
                                    v-model="data.filters"
                                    :searchable="false"
                                    @input="changeSearch()"
                                    :placeholder="$store.state.translation.search.text4"
                                    class="filter"
                                    label="name"
                                    data-id="1">
                                    <template v-slot:no-options="{ search, searching }">
                                      <template v-if="searching">
                                          {{ $store.state.translation.default.select_not_found }}
                                      </template>
                                    </template>
                                </v-select>
                            </div>
                        </div>
                    </div>

                    <h2 class="search__title" v-if="search_count == 1">{{ $store.state.translation.search.text5 }}</h2>
                    <h2 class="search__title" v-if="!games.length && search_count > 1 && !preloader">{{ $store.state.translation.search.text6 }}</h2>

                    <div class="search__cards game-cards">

                        <div class="games-preloader" v-if="preloader">
                            <div class="preloader__row">
                                <div class="preloader__item"></div>
                                <div class="preloader__item"></div>
                            </div>
                        </div>

                        <div class="game-cards__container">

                            <div class="game-cards__item game-card" v-for="game in games">
                                <div class="game-slider__label new" v-if="game.is_new">
                                    <span>NEW</span>
                                    <svg width="59" height="29" viewBox="0 0 59 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M0 0H59V25.8929L9.83333 29L0 0Z"></path>
                                    </svg>
                                </div>
                                <div class="game-slider__label hit" v-if="game.is_hit && !game.is_new">
                                    <span>HIT</span>
                                    <svg width="59" height="29" viewBox="0 0 59 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M0 0H59V25.8929L9.83333 29L0 0Z"></path>
                                    </svg>
                                </div>

                                <div v-if="'auth' in $store.state.user && $store.state.user.auth">
                                    <div
                                        v-if="$store.state.user.data.games_favourite.includes(game.id)"
                                        :class="{
                                            'favourite': $store.state.user.data.games_favourite.includes(game.id),
                                            'not__only': game.is_new || game.is_hit
                                        }"
                                        @click="favourite(game.id)"
                                        class="game-slider__label">
                                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" height="20px" width="20px" version="1.1" viewBox="-2.88 -2.88 53.70 53.70" xml:space="preserve" fill="#ff0" stroke="#ff0" stroke-width="4.794">
                                            <g>
                                                <path d="M26.285,2.486l5.407,10.956c0.376,0.762,1.103,1.29,1.944,1.412l12.091,1.757 c2.118,0.308,2.963,2.91,1.431,4.403l-8.749,8.528c-0.608,0.593-0.886,1.448-0.742,2.285l2.065,12.042 c0.362,2.109-1.852,3.717-3.746,2.722l-10.814-5.685c-0.752-0.395-1.651-0.395-2.403,0l-10.814,5.685 c-1.894,0.996-4.108-0.613-3.746-2.722l2.065-12.042c0.144-0.837-0.134-1.692-0.742-2.285l-8.749-8.528 c-1.532-1.494-0.687-4.096,1.431-4.403l12.091-1.757c0.841-0.122,1.568-0.65,1.944-1.412l5.407-10.956 C22.602,0.567,25.338,0.567,26.285,2.486z" style="fill: #ff0;"></path>
                                            </g>
                                        </svg>
                                        <svg viewBox="145.012 146.324 34.675 29" width="34.675" height="29">
                                          <path d="M 145.012 146.324 L 179.687 146.324 L 179.687 172.217 L 150.791 175.324 L 145.012 146.324 Z" style=""></path>
                                        </svg>
                                    </div>
                                </div>

                                <div class="game-card__main">
                                    <div class="game-card__img">
                                       <img :src="game.image" width="175" height="120" :alt="game.name">
                                    </div>
                                    <div class="game-card__hover game-slider-hover">
                                        <div v-if="'auth' in $store.state.user && $store.state.user.auth">
                                            <div
                                                @click="favourite(game.id)"
                                                class="game-fauvorite">
                                                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" height="20px" width="20px" version="1.1" viewBox="-2.88 -2.88 53.70 53.70" xml:space="preserve" fill="#e9417d" stroke="#e9417d" stroke-width="4.794">
                                                    <g>
                                                        <path :class="{'not_selected': !$store.state.user.data.games_favourite.includes(game.id)}" d="M26.285,2.486l5.407,10.956c0.376,0.762,1.103,1.29,1.944,1.412l12.091,1.757 c2.118,0.308,2.963,2.91,1.431,4.403l-8.749,8.528c-0.608,0.593-0.886,1.448-0.742,2.285l2.065,12.042 c0.362,2.109-1.852,3.717-3.746,2.722l-10.814-5.685c-0.752-0.395-1.651-0.395-2.403,0l-10.814,5.685 c-1.894,0.996-4.108-0.613-3.746-2.722l2.065-12.042c0.144-0.837-0.134-1.692-0.742-2.285l-8.749-8.528 c-1.532-1.494-0.687-4.096,1.431-4.403l12.091-1.757c0.841-0.122,1.568-0.65,1.944-1.412l5.407-10.956 C22.602,0.567,25.338,0.567,26.285,2.486z"></path>
                                                    </g>
                                                </svg>
                                            </div>
                                        </div>

                                       <template v-if="'auth' in $store.state.user && $store.state.user.auth">
                                            <router-link :to="{name: 'Game', params: {mode: 'real', slug: game.slug}}" class="game-slider-hover__play">
                                                <svg width="13" height="16" viewBox="0 0 13 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M12 6.26795C13.3333 7.03775 13.3333 8.96225 12 9.73205L3 14.9282C1.66667 15.698 -7.31543e-07 14.7358 -6.64245e-07 13.1962L-2.09983e-07 2.80385C-1.42685e-07 1.26425 1.66667 0.301995 3 1.0718L12 6.26795Z"
                                                        fill="white"/>
                                                </svg>
                                            </router-link>
                                        </template>
                                        <template v-else>
                                            <button type="button" class="game-slider-hover__play" @click="openPopup('sign-in')">
                                                <svg width="13" height="16" viewBox="0 0 13 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M12 6.26795C13.3333 7.03775 13.3333 8.96225 12 9.73205L3 14.9282C1.66667 15.698 -7.31543e-07 14.7358 -6.64245e-07 13.1962L-2.09983e-07 2.80385C-1.42685e-07 1.26425 1.66667 0.301995 3 1.0718L12 6.26795Z"
                                                        fill="white"/>
                                                </svg>
                                            </button>
                                        </template>
                                        <router-link :to="{name: 'Game', params: {mode: 'demo', slug: game.slug}}" class="game-slider-hover__link">{{ $store.state.translation.search.text7 }}</router-link>
                                    </div>
                                </div>
                                <div class="game-card__footer">
                                    <div class="game-card__title">{{game.name}}</div> 
                                    <div class="game-card__title game-card__title--hover">{{game.name}}</div> 
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>

            <div class="show-more show-more--mb">
                <div class="show-more__container">
                    <div class="show-more__row show-more__row--center">
                        <button type="button" class="show-more__more" v-if="!nomore" @click.prevent="search(true)" :class="{'_disabled': preloader}">
                            <span>{{ $store.state.translation.default.show_more }}</span>
                        </button>
                    </div>
                </div>
            </div>

        </main>

        <footer-main></footer-main>
    </div>
</template>


<script>
    export default {
        metaInfo () {
            return {
                title: this.$store.state.translation.search.meta.title,
                meta: [
                    {
                        name: 'title', 
                        content: this.$store.state.translation.search.meta.title,
                    },
                    {
                        name: 'keywords', 
                        content: this.$store.state.translation.search.meta.keywords,
                    },
                    {
                        name: 'description', 
                        content: this.$store.state.translation.search.meta.description,
                    }
                ]
            }
        },
        data() {
            return {
                preloader: true,
                search_count: 0,
                nomore: true,
                games: [],
                data: {
                    query: null,
                    provider: null,
                    category: null,
                    filters: null,
                    limit: 105,
                    offset: 0
                },
                filters: {
                    providers: [{
                        name: this.$store.state.translation.search.text8,
                        id: 0
                    }],
                    categories: [{
                        name: this.$store.state.translation.search.text9,
                        id: 0
                    }],
                    options: [
                        {
                            name: this.$store.state.translation.search.text10,
                            key: 'is_favourite'
                        },
                        {
                            name: this.$store.state.translation.search.text11,
                            key: 'in_tournaments'
                        },
                        {
                            name: this.$store.state.translation.search.text12,
                            key: 'bonus_buy'
                        },
                        {
                            name: this.$store.state.translation.search.text13,
                            key: 'is_megaways'
                        }
                    ]
                },
                searchTimeout: null
            }
        },
        methods: {
            async search () {
                this.preloader = true
                this.search_count++
                await this.$axios.post('/games/search', JSON.stringify({
                    type: 'search',
                    query: this.data.query,
                    provider: this.data.provider ? this.data.provider.id : null,
                    category: this.data.category ? this.data.category.id : null,
                    filters: {
                        is_favourite: this.data.filters && this.data.filters.key == 'is_favourite' ? true : false,
                        in_tournaments: this.data.filters && this.data.filters.key == 'in_tournaments' ? true : false,
                        bonus_buy: this.data.filters && this.data.filters.key == 'bonus_buy' ? true : false,
                        is_megaways: this.data.filters && this.data.filters.key == 'is_megaways' ? true : false
                    },
                    limit: this.data.limit,
                    offset: this.data.offset
                }))
                .then((response) => {
                    this.setLoaded(true)
                    response = response.data
                    switch (response.status) {
                        case 'error':
                            this.$toast.error(response.message)
                            break
                        case 'success':

                            if(response.data.length) {
                                this.games = this.games.concat(response.data)
                            } else {
                                this.games = []
                            }

                            this.data.offset ++

                            this.nomore = response.data.length < this.data.limit ? true : false

                            this.preloader = false

                            this.setUser(response.user)
                            
                            break
                        default:
                            this.$toast.error(this.$store.state.translation.default.unknown_error)
                    }
                }).catch((error) => {
                    let response = error.response.data
                    if(response && 'status' in response && response.status == 'error') {
                        this.$toast.error(response.message)
                    }
                })
            },
            getProviders () {
                this.$axios.post('/games/filter/providers')
                .then((response) => {
                    response = response.data
                    switch (response.status) {
                        case 'error':
                            this.$toast.error(response.message)
                            break
                        case 'success':

                            for (let item of response.data) {
                                this.filters.providers.push({
                                    name: item.name,
                                    id: item.id
                                })
                            }

                            this.setUser(response.user)
                            
                            break
                        default:
                            this.$toast.error(this.$store.state.translation.default.unknown_error)
                    }
                }).catch((error) => {
                    let response = error.response.data
                    if(response && 'status' in response && response.status == 'error') {
                        this.$toast.error(response.message)
                    }
                })
            },
            getCategories () {
                this.$axios.post('/games/filter/categories')
                .then((response) => {
                    response = response.data
                    switch (response.status) {
                        case 'error':
                            this.$toast.error(response.message)
                            break
                        case 'success':

                            for (let item of response.data) {
                                this.filters.categories.push({
                                    name: item.name,
                                    id: item.id
                                })
                            }

                            this.setUser(response.user)
                            
                            break
                        default:
                            this.$toast.error(this.$store.state.translation.default.unknown_error)
                    }
                }).catch((error) => {
                    let response = error.response.data
                    if(response && 'status' in response && response.status == 'error') {
                        this.$toast.error(response.message)
                    }
                })
            },
            favourite (game) {
                this.$axios.post('/games/favourite', JSON.stringify({
                    game: game
                }))
                .then((response) => {
                      response = response.data
                      switch (response.status) {
                          case 'error':
                              break
                          case 'success':

                              this.setUser(response.user)

                              break
                          default:
                          //Error
                      }
                })
            },
            changeSearch () {
                this.preloader = true

                this.games = []
                this.data.offset = 0

                if(!this.searchTimeout) {
                    this.searchTimeout = true
                    setTimeout(() => {
                        this.searchTimeout = false
                        this.search()
                    }, 1000)
                }
            }
        },
        beforeMount() {
            this.setLoaded(false)
            this.search()
            this.getProviders()
            this.getCategories()
        }
    }
</script>

